import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var StartView = /** @class */ (function (_super) {
    tslib_1.__extends(StartView, _super);
    function StartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.designerCode = "";
        _this.message = "";
        _this.messageTimeout = null;
        return _this;
    }
    StartView.prototype.mounted = function () {
        this.$state.mode = "worktop";
        if (this.$state.externalEmbed)
            this.$router.push("/worktop");
    };
    Object.defineProperty(StartView.prototype, "bodyStyles", {
        get: function () {
            return {
                "background-image": "url('" + this.$ui.texts.frontpageMain.images[0] + "')"
            };
        },
        enumerable: true,
        configurable: true
    });
    StartView.prototype.setDesignerCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var code, self_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clearTimeout(this.messageTimeout);
                        code = this.designerCode.toUpperCase();
                        if (!(code == "T")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.testData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.$store.cart.setDesignerCode(code)];
                    case 3:
                        _a.sent();
                        console.log(this.$store.cart.isCurrentCodeValidWorktopCode);
                        if (this.$store.cart.isCurrentCodeValidWorktopCode) {
                            this.message = null;
                            this.$state.mode = "worktop";
                            this.$router.push({ name: "Summary" });
                        }
                        else if (this.$store.cart.isCurrentCodeValidBackpanelCode) {
                            this.message = null;
                            this.$state.mode = "backpanel";
                            this.$router.push({ name: "Summary" });
                        }
                        else {
                            self_1 = this;
                            this.message = this.$ui.t("invalidDesignerCode");
                            this.messageTimeout = setTimeout(function () { self_1.message = null; }, 3000);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    StartView.prototype.testData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$store.cart.setDesignerCode("PLAN-000066")];
                    case 1:
                        _a.sent();
                        this.$router.replace("/sink");
                        return [2 /*return*/];
                }
            });
        });
    };
    StartView = tslib_1.__decorate([
        Component
    ], StartView);
    return StartView;
}(Vue));
export default StartView;
